import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { APIService } from '../../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
import { ProductDetailComponent } from 'src/app/inventory/product-detail/product-detail.component';
import { ProjectTypeEntryComponent } from '../project-type-entry/project-type-entry.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-project-type-list',
  templateUrl: './project-type-list.component.html',
  styleUrls: ['./project-type-list.component.scss']
})
export class ProjectTypeListComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  cntTotalItems: number = 0;
  showItemList: boolean = true;
  jarvisData: any = [];
  agencyData: any = [];
  modalReference: any;

  constructor(private apiService: APIService, private SpinnerService: NgxSpinnerService, private modalService: NgbModal, private commonService: CommonService, private location: Location) {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      if (this.apiService.checkIsPremiumOrTrial() == false){
        if (this.apiService.fn_isLiveURL() == true)
        {
          window.location.href = "https://biziverse.com/main.html#/home";
          return;
        }
        else{
          window.location.href = "main.html#/home";
          return;
        }    
      } 
    }

    let erpAgn: any = this.apiService.getCookie("ERP_Agn");
    let enblProjects = false;
    if (erpAgn) {
        erpAgn = JSON.parse(erpAgn);
        if (erpAgn.length > 0) {
          enblProjects = erpAgn[0].EnblProjects;
        }
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      
      if(!this.right.Inv && !this.right.InvCfg && !this.right.InvMstrs && !enblProjects && !(this.right.Prd && this.right.PrdRpts && this.right.PrdCfg)){
        window.location.href = "../../main.html#/home";
        return;
      }
    }
  }

  ngOnInit(): void {
    if (this.agencyData.length > 0 && this.jarvisData.length > 0) {
      this.isAdmin = (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) ? true : false;
    }

    const openEntry: any = this.commonService.GetParam('o');
    if (openEntry && openEntry == 1) {
      this.open();
      let url = this.apiService.fn_isLiveURL() == true ? '/ERP/ProjectTypes' : '/ProjectTypes';
      this.location.go(url);
    }

    this.getData();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  dataSource: any = [];
  displayedColumns: string[] = ['ItemName', 'ItemCode', 'Actions']; 
  Items: any = [];
  exportToExcel: any = [];
  right: any;
  isAdmin: boolean = false;
  itemName: any = '';
  filter: any = 0;
  search: string = '';
  stockItems: any = [];

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        //window.location.href = uri + base64(format(template, ctx))
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()

  getData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data = [{
      StatusID: 1,
      StoreID: 0,
      IsFromList: 1,
      changeType: 'ALLITM'
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  //successResp - success  get handler
  successRespItem(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
     
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let data = reponseData;
          let allItems = data.Table1;
          allItems = allItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
          this.stockItems = allItems.filter((item: any) => item.ItemType == 'I' && item.IsActive == 1);

          let tempItems = allItems.filter((item: any) => item.ItemType == 'P');
          this.Items = tempItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
      
          // If added first item, set the filter to 'All Stock Items'.
          this.cntTotalItems = this.Items.length;
          this.showItemList = this.cntTotalItems > 0 ? true : false;
          
          this.dataSource = new MatTableDataSource(this.Items);
          this.exportToExcel = this.Items;
          
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.matSort;
        }
      }
    }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  openItemEdit(obj: any): void {
    this.modalReference = this.modalService.open(ProductDetailComponent, { windowClass: 'modal-item-Edit', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.ItemID = obj.ItemID;
    this.modalReference.componentInstance.stockItems = this.stockItems;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if (result?.action == 'Done') {
        this.getData();
      }
    });
  }

  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  backToHomeBtn() {
    window.location.href = "https://biziverse.com/main.html#/home";
  }

  //export to excel
  exportToExcelActivities() {
    var html = "";
    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Stock</th>"
    html += "</table></tr>"; 

    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    html += "</table></tr>";

    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Item</th>";
    strHeader += "<th style='text-align: left;'>Code</th>";

    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      body += "<td style='text-align: left;'>" + item.ItemName + "</td>";
      body += "<td style='text-align: left;'>" + item.ItemCode + "</td>";
      
    body += "</tr>";
    })
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', 'Stock');
  }

  open() {
    this.modalReference = this.modalService.open(ProjectTypeEntryComponent, { windowClass: 'project-type-entry', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if (result?.action == 'Done') {
        this.getData();
      }
    });
  }

  deleteItem(obj: any) {

    var r = confirm("Are you sure you want to delete this project type?");
    if (r == true) {

      let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

      //Validation
      if (obj == "") {
        this.apiService.successAlert('Please select a project type.');
        return;
      }

      else {
        var tempData = [{
          'ItemID': obj.ItemID
        }]

        let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: MyLastSyncDT,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'Delete',
          moduleID: 5,
          data: JSON.stringify(tempData)
        }];

        this.apiService.sendChange(myParams, this.successDelete.bind(this), this.failureDelete.bind(this));
      }
    }
    else {
      return
    }
  }
  //failureResp - failure handler
  failureDelete(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successDelete(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          this.getData();
        }
      }
    }
  }

}
